import React from "react";
import { withTheme } from 'styled-components';
import { Select } from 'antd';
import { Flex, FlexColumn } from "./Container";
import _ from "underscore";
import { generateSimplePlaceholder } from '../../Utils/util'

const { Option } = Select;

class IntQuoteLocationInput extends React.Component {
	constructor(props) {
		super(props);
		const value = props.value || {};
		const address = props.address || {};
		this.state = {
			formData: {},
			...value,
			...address
		};
		this.autocompleteInput = React.createRef();
	}

	validateInput = (key, value) => {
		const regexPattern = this.props.internationalQuoteRequirements?.[key];
		return regexPattern ? new RegExp(regexPattern).test(value) : true;
	};

	handleTextChange = (event) => {
		var updatedState = this.state
		const { id, value } = event.target;
		const trimmedValue = value.trimStart();
		updatedState[event.target.id] = trimmedValue
		if (event.target.id === "state") updatedState["countrySubDivisionCode"] = trimmedValue
		if (_.isEmpty(trimmedValue)) updatedState[event.target.id] = null

		this.setState(updatedState)
		this.props.getLocation(updatedState, this.state.formattedAddress)
	};

	handleSelectCountry = (country) => {
		this.setState({ country });
	};

	render() {
		const { internationalQuoteRequirements, theme } = this.props;
		var { line1, line2, city, countrySubDivisionCode, state, postalCode, country } = this.state

		return (
			<FlexColumn style={{ width: '100%', padding: '8px 0' }} left>
				{internationalQuoteRequirements?.address && <>
					<input
						className="location-input"
						type="text"
						placeholder={internationalQuoteRequirements ? generateSimplePlaceholder("Street", internationalQuoteRequirements?.address) : "Street"}
						id="line1"
						value={line1 || ''}
						onChange={this.handleTextChange}
						autoComplete='off'
					/>
					<input
						className="location-input"
						type="text"
						placeholder="Suite/Floor (e.g. Suite 600)"
						id="line2"
						value={line2 || ''}
						onChange={this.handleTextChange}
						autocomplete='off'
						data-lpignore="true"
					/>
				</>
				}
				{internationalQuoteRequirements?.city && (
					<input
						className="location-input"
						type="text"
						placeholder={internationalQuoteRequirements ? generateSimplePlaceholder("City", internationalQuoteRequirements?.city) : "City"}
						id="city"
						value={city || ''}
						onChange={this.handleTextChange}
						autoComplete='off'
					/>
				)}
				<Flex style={{ width: '100%' }} between>
					{internationalQuoteRequirements?.stateProvince && (
						<input
							className="location-input"
							type="text"
							placeholder={internationalQuoteRequirements ? generateSimplePlaceholder("State/Province", internationalQuoteRequirements?.stateProvince) : "State/Province"}
							id="state"
							value={state || ''}
							onChange={this.handleTextChange}
							autoComplete='off'
						/>
					)}
					{internationalQuoteRequirements?.postalCode && (
						<input
							className="location-input"
							type="text"
							placeholder={internationalQuoteRequirements ? generateSimplePlaceholder("Postal Code", internationalQuoteRequirements?.postalCode) : "Postal Code"}
							id="postalCode"
							value={postalCode || ''}
							onChange={this.handleTextChange}
							autoComplete='off'
						/>
					)}
				</Flex>
			</FlexColumn>
		);
	}
}
export default withTheme(IntQuoteLocationInput);